<template>
  <header>
    <div class="logo">
      <img src="../assets/logo.png" alt="" />
      <a href="#">Brand<span>Colors</span></a>
    </div>
    <h2>
      The biggest collection of official brand <br />
      color codes around. Curated by <br />
      <a href="https://twitter.com/brandcolors">@brandcolors</a> and
      <a href="https://github.com/brandcolors/feedback/issues">friends</a>.
    </h2>
    <nav>
      <ul>
        <li>
          <a href="https://github.com/brandcolors/feedback" target="_blank">
            Suggest a Brand
          </a>
        </li>
        <li>
          <a href="#"> About BrandColors </a>
        </li>
      </ul>
    </nav>
    <a class="details-color" href="#">
      <span>Brand<strong>Colors</strong> + DesignBombs</span>
      Learn how to make a website - we have put together an in-depth guide that
      will help you build your first website with WordPress.
    </a>
    <div class="share">
      <a class="twitter" href="#">
        <i class="fab fa-twitter"></i>
      </a>
      <a class="facebook" href="#">
        <i class="fab fa-facebook-f"></i>
      </a>
      <a class="linkedin" href="#">
        <i class="fab fa-linkedin-in"></i>
      </a>
      <a class="pinterest" href="#">
        <i class="fab fa-pinterest"></i>
      </a>
    </div>
  </header>
</template>
